import messages_en from "./translations_en";
import messages_nl from "./translations_nl";

export const translationSets = {
	nl: messages_nl,
	en: messages_en
};
